import React from "react"
import QuietNotes from "../components/previews/QuietNotes"
import { usePreviewPosts, withPreviewLinks } from "../components/previews/data"
import SEO from "../components/seo"

export default function BlogPostTemplate({ pageContext }) {
  const posts = withPreviewLinks(usePreviewPosts(), "")
  const post = posts.find(item => item.slug === pageContext.slug)
  if (!post) return null
  return (
    <>
      <SEO
        title={post.title}
        description={post.description}
        pathname={post.draft ? undefined : post.slug}
        meta={post.draft ? [{ name: "robots", content: "noindex, nofollow" }] : []}
        article
      />
      <a className="quiet-skip" href="#quiet-main">Skip to the article</a>
      <QuietNotes posts={posts} post={post} basePath="" />
    </>
  )
}
